import AddCompany from './add';
import Table from '../../../../shared/table';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../utils/customModal';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { instanceAction } from '../../../../../Redux/api';
import { MOD_CUSTOM, WRITE } from '../../../../../permissions';
import { getRoles } from "../../../../../Redux/reducer/session";
import plusImage from "../../../../../../static/images/plus.svg";
import CompanyForm from "../../../../shared/customer/companyForm";
import ActionMenuList from 'canvas-core-react/lib/ActionMenuList';
import { relatedCompanies } from '../../../../../Redux/reducer/cifCross';
import ActionMenuListItem from 'canvas-core-react/lib/ActionMenuListItem';
import { getCreditLineByCif } from '../../../../../Redux/actions/credit-line';
import { getClientByCif, getClientAccounts } from '../../../../../Redux/actions/clientActions';
import { getInstitutionsProfile, getClient, getAccounts } from '../../../../../Redux/reducer/clients';
import { moduleAction, loadingHtml, errorContainer, sucessInfoModal } from '../../../../utils/functions';
import { getRelatedCompanies, getCifCrossChilds, clearRelatedCompanies } from '../../../../../Redux/actions/cifCrossActions';

import IconShow from 'canvas-core-react/lib/IconShow';
import StatusBadge from 'canvas-core-react/lib/StatusBadge';
import iconEdit from "../../../../../../static/images/icon-addnew-18px.svg";

const RelatedCompanies = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [menus, setMenus] = useState([]);

    const headers = [
        { selector: "companyName", name: t("clients.table.name") },
        { selector: "cif", name: t("clients.table.cif") },
        { selector: "identification", name: t("clients.table.id") },
        { selector: "state", name: t("clients.table.state") },
        {
          selector: "actions",
          name: t("clients.table.actions"),
          center: true,
          cellFormatter: (row) => <ActionMenuList
            dialogPosition="bottom-right"
            iconType="horizontal-small"
            bottomSheet={{
              heading: "Actions",
              secondaryAction: {
                onClick: () => {},
                label: "Cancel"
              }
            }}
            isMenuOpen={menus[`menu-${row.id}`] || false }
            setIsMenuOpen={(open) => handleMenu(row.id, open) }
          >
            <ActionMenuListItem 
              icon={() => <IconShow id={`related-${row.id}`} className="TextButton__icon--left" />}
              onClick={() => loadCompany(row.cif, institution.country.code, row.id)}>
                {t("general.labels.viewProfile")}
            </ActionMenuListItem>
          </ActionMenuList>
        },
    ];

    const roles = useSelector(state => getRoles(state));
    const company = useSelector(state => getClient(state));
    const accounts = useSelector(state => getAccounts(state));
    const companies = useSelector(state => relatedCompanies(state));
    const institution = useSelector((state) => getInstitutionsProfile(state));

    // Esto tiene que salir por medio de permisos
    const edit = moduleAction(roles, MOD_CUSTOM, WRITE);
    const [actions, setActions] = useState({ list: true, add: false, company: false });
    const [modal, setModal] = useState({ show: false, onClose: undefined, content: null });
    const [formProps, setFormProps] = useState({ enableEdit: true, editCompany: false, countryCode: '', method: '', back: undefined });

    useEffect(() => {
      setModal({ show: true, content: loadingHtml(), onClose: undefined });
      dispatch(getRelatedCompanies(institution.cif))
        .then(() => setModal({ show: false, content: null, onClose: undefined }));

      return () => {
        // Limpiamos data
        dispatch(clearRelatedCompanies());
      }
    }, []);

    const handleMenu = (id, open) => {
      const tmpMenu = [...menus];
      tmpMenu[`menu-${id}`] = open;
      setMenus(tmpMenu);
    }

    const getData = () => {
      var data = [];

      if( companies.length > 0 ) {
        var estado = null;
        companies.map((company) => {
          if (company.statusCompany === "TRANSITORY") {
            estado = (
              <StatusBadge className="pending-client" type="default">{t("general.states.PENDING")}</StatusBadge>
            );
          // } else if (item.company.pendingChange === true) {
          //   estado = (
          //     <StatusBadge className="pending-client" type="default">
          //       Pendiente cambios
          //     </StatusBadge>
          //   );
          } else if (company.statusCompany === "ACTIVE") {
            estado = <StatusBadge className="success">{t("general.states.ACTIVE")}</StatusBadge>;
          } else if (company.statusCompany === "INACTIVE") {
            estado = (
              <StatusBadge className="error1" type="error">{t("general.states.INACTIVE")}</StatusBadge>
            );
          } else if (company.statusCompany === "REJECTED") {
            estado = (
              <StatusBadge className="rejected-payment" type="error">{t("general.states.REJECTED")}</StatusBadge>
            );
          }

          data.push({
            id: company.companyId,
            companyName: company.nameCompany,
            cif: company.cif,
            identification: company.businessId,
            state: estado,
          });
        });
      }
      return data;
    }

    const closeModal = () => {
      setModal({ show: false, onClose: undefined, content: null });
    }

    const addCompanies = () => {
      setModal({ show: true, content: loadingHtml(t("clients.related.modal.loadingRelated")), onClose: undefined });
      return dispatch(getCifCrossChilds(institution.cif, institution.country.code)).then(() => { 
        closeModal();
        setActions({ list: false, add: true, company: false})
      }).catch((err) => showError(err));
    }

    const loadCompany = (cif, country, relatedId = null) => {
      if(relatedId !== null) { handleMenu(relatedId, false); }
      setModal({ show: true, content: loadingHtml(t("clients.related.modal.loadingProfile")), onClose: undefined });

      var client = relatedId === null ? cif : relatedId;

      return dispatch(getClientByCif(client, country, relatedId !== null)).then(() => {
        setModal({ show: true, content: loadingHtml(t("clients.related.modal.loadingLines")), onClose: undefined });

        // Update Form Props
        if( relatedId !== null ) { // UPDATE
          setFormProps({ enableEdit: false, editCompany: true, countryCode: country, method: 'UPDATE', back: loadIndex });
        } else {
          setFormProps({ enableEdit: true, editCompany: false, countryCode: country, method: 'CREATE', back: () => setActions({ list: false, add: true, company: false}) });
        }

        dispatch(getCreditLineByCif(cif, country))
          .then(() => {
            setModal({ show: true, content: loadingHtml(t("clients.related.modal.loadingAccounts")), onClose: undefined });

            dispatch(getClientAccounts(cif, country))
              .then(() => {
                closeModal();
                setActions({ list: false, add: false, company: true})
              })
              .catch((err) => showError(err));
          })
          .catch((err) => showError(err));
      }).catch((err) => showError(err));
    }

    const showError = (err, save = false) => {
      if(save){
        setFormProps({ enableEdit: true, editCompany: false, countryCode: '', method: '', back: undefined });
      }

      var buttons = { cancelBtn: { text: t("general.buttons.back"), action: closeModal } };
      if( err.response.data.notifications !== undefined ) {
        const notification = err.response.data.notifications[0];
        setModal({
          show: true,
          content: errorContainer(notification.message, notification.description, buttons), 
          onClose: closeModal });
      } else {
        setModal({
          show: true,
          content: errorContainer(t("general.labels.errorTitle"), t("general.labels.defaultError"), buttons), 
          onClose: closeModal });
      }
      
    }

    const save = (data) => {
      const save = formProps.method === 'CREATE';
      const saveUrl = save ? `/cif-cross` : `/companies/${company.company.id}`;
      const method = save ? 'post' : 'put';
      const objData = save ? { cifChilds: [data], cifParent: institution.cif} : data;
  
      setModal({ show: true, content: loadingHtml(), onClose: undefined});
  
      return dispatch(instanceAction(saveUrl, method, objData))
        .then(() => {
          // Procedemos a ligar la empresa con el cif correspondiente
          var button = { formBtn: { text: t("general.buttons.accept"), action: loadIndex } }
          setModal({
            show: true,
            content: sucessInfoModal(t("clients.related.modal.successTitle"), t("clients.related.modal.successMessage"), button),
            onClose: loadIndex
          });
        })
        .catch((err) => showError(err, true));
    }

    const loadIndex = () => {
      setActions({ list: true, add: false, company: false });
      setModal({ show: true, content: loadingHtml(), onClose: undefined });
      dispatch(getRelatedCompanies(institution.cif))
        .then(() => setModal({ show: false, content: null, onClose: undefined }));
    }

    return <div className="related-companies">
      {actions.list && <>
        {edit && (
          <a className="add-company flex-element" onClick={addCompanies}>
            <p className="bsc-add-client">{t("clients.related.add")}</p>
            <img src={plusImage} />
          </a>
        )}
        <Table headers={headers} data={getData()} page={1} />
      </>}
      {actions.add && <AddCompany back={loadIndex} next={loadCompany} />}
      {actions.company && 
        <div className="proof">
          {edit && !formProps.enableEdit && (
            <div className="new-edit-div-client">
              <p className="new-edit-provider" onClick={() => setFormProps({ ...formProps, enableEdit: true })}>{t("general.labels.edit")}</p>
              <img src={iconEdit} className="iconEdit" />
            </div>
          )}
          <CompanyForm
            company={company}
            enableEdit={formProps.enableEdit}
            editCompany={formProps.editCompany}
            goBack={formProps.back}
            countryCode={ formProps.countryCode } 
            accounts={accounts}
            save={save}
            method={formProps.method}
          />
        </div>
      }
      <Modal show={modal.show} handleClose={modal.onClose}>{modal.content}</Modal>
    </div>;
};

export default RelatedCompanies;